module.exports = __webpack_public_path__ + "img/contagem-logo-light.9ab2648b.png";